import React from "react";
import { useNavigate } from "react-router-dom";
import './MobileLogout.css'; 

function MobileLogout({ onClose }) {  
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear local storage
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");

    // Navigate to login
    navigate("/adminm/login", { replace: true });
  };

  const handleCancel = () => {
    if (onClose) onClose();
  };

  return (
    <div className="mobile-logout-overlay">
      <div className="mobile-logout-box">
        <h2 className="mobile-logout-title">Logout</h2>
        <p className="mobile-logout-text">Are you sure you want to logout?</p>
        <div className="mobile-logout-buttons">
          <button className="mobile-cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="mobile-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileLogout;
